import { isObject } from './isObject';
import { forEach } from './iterable/forEach';
import { reduce } from './iterable/reduce';

import { SEPARATOR } from '../constants';

export function getFromLocalStorage(values) {
  function reduceValuesAt(path = []) {
    return function reduceValues(result, notSetValue, key) {
      if (isObject(notSetValue)) {
        result[key] = reduce(notSetValue, {}, reduceValuesAt([...path, key]));
      } else {
        try {
          result[key] = JSON.parse(window.localStorage.getItem([...path, key].join(SEPARATOR.UNDERSCORE)));
        } catch (error) {
          result[key] = notSetValue;
        }
      }

      return result;
    };
  }

  return reduce(values, {}, reduceValuesAt());
}

export function saveToLocalStorage(values) {
  function forEachValueAt(path = []) {
    return function forEachValue(value, key) {
      if (isObject(value)) {
        forEach(value, forEachValueAt([...path, key]));
      } else {
        try {
          if (value === undefined) {
            window.localStorage.removeItem([...path, key].join(SEPARATOR.UNDERSCORE));
          } else {
            window.localStorage.setItem([...path, key].join(SEPARATOR.UNDERSCORE), JSON.stringify(value));
          }
        } catch (error) {
          console.error(error);
        }
      }
    };
  }

  forEach(values, forEachValueAt());
}
